import React from 'react';
import Layout from 'layout';
import { ExtendGridBox } from 'pages/integrations/analytics';
import SideBar from 'components/marketplace/sideBar';
import Content from 'components/marketplace/content';
import Banner from 'components/marketplace/banner';
import { frontmatter } from 'data/marketplace/integrations';
import arrow from 'img/ui/arrow_black.svg';
import OwnAppSection from 'components/marketplace/ownAppSection';

const ECommerce = () => {
  const [mostPopularCard] = frontmatter.items.filter((item) => item.title === 'Shopify');
  return (
    <Layout
      metaTitle="E-commerce | Integrations"
      canonical="/integrations/e-commerce/"
      metaDescription="LiveSession and e-commerce go hand in hand. Boost your online shop with our integrations."
    >
      <div className="container">
        <ExtendGridBox>
          <div className="breadcrumbs">
            <p>
              <a href="/integrations/">Integrations</a>
            </p>
            <img src={arrow} alt="arrow" title="Arrow" />
            <p>
              <a href="/integrations/e-commerce/">
                <strong>E-commerce</strong>
              </a>
            </p>
          </div>
          <SideBar activeCategory="E-commerce" underlineColor="#7DFFEF" />
          <Content activeCategory="E-commerce" hideTitle>
            <Banner
              activeCategory="E-commerce"
              card={mostPopularCard}
              text="LiveSession and e-commerce go hand in hand. Boost your online shop with our integrations."
              underlineColor="#7DFFEF"
            />
          </Content>
        </ExtendGridBox>
        <OwnAppSection />
      </div>
    </Layout>
  );
};

export default ECommerce;
